import { RouteRecordRaw } from 'vue-router';
import { StudentRouteName } from '../constants/routesName';
import { UserRole, ROUTE_CATEGORY } from '../types';

const AbsencesPage = () => import('@/features/absences/views/AbsencesPage.vue');
const AgendaView = () => import('@/features/agenda/views/AgendaView.vue');
const AroundTheWorldMap = () => import('@/features/around-the-world/views/AroundTheWorldMap.vue');
const ChatView = () => import('@/features/chat/views/ChatView.vue');
const HomePageStudent = () => import('@/features/homepage/views/HomePageStudent.vue');
const LiaisonDocumentDashboard = () =>
  import('@/features/liaison-document/liaisonDocumentDashboard/LiaisonDocumentDashboard.vue');
const LiaisonDocumentForm = () =>
  import('@/features/liaison-document/liaisonDocumentForm/views/LiaisonDocumentForm.vue');
const NotesPage = () => import('@/features/notes/views/NotesPage.vue');
const ShopPage = () => import('@/features/shop/views/Shop.vue');

/**
 * Routes dédiées aux étudiants
 */
export const studentRoutes: RouteRecordRaw[] = [
  {
    path: '/student-home',
    name: StudentRouteName.StudentHome,
    component: HomePageStudent,
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.studentHome',
      icon: 'home-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/absences',
    name: StudentRouteName.Absences,
    component: AbsencesPage,
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.absences',
      icon: 'time-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/agenda',
    name: StudentRouteName.Agenda,
    component: AgendaView,
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.agenda',
      icon: 'calendar-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/around-the-world',
    name: StudentRouteName.AroundTheWorld,
    component: AroundTheWorldMap,
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.aroundTheWorld',
      icon: 'globe-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/chat',
    name: StudentRouteName.Chat,
    component: ChatView,
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.chat',
      icon: 'chatbubble-ellipses-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/notes',
    name: StudentRouteName.Notes,
    component: NotesPage,
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.notes',
      icon: 'school-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/chatbot',
    name: 'Chatbot',
    component: () => import('@/features/chatbot/views/ChatbotView.vue'),
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.chatbot',
      icon: 'chatbubble-outline',
      category: 'student',
    },
  },
  {
    path: '/shop',
    name: StudentRouteName.Shop,
    component: ShopPage,
    meta: {
      requiresRoles: [UserRole.STUDENT],
      title: 'routes.shop',
      icon: 'storefront',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/stage-alternance',
    name: StudentRouteName.StageAlternance,
    component: LiaisonDocumentDashboard,
    meta: {
      title: 'routes.stageAlternance',
      requiresRoles: [UserRole.STUDENT],
      category: ROUTE_CATEGORY.STUDENT,
      hideInMenu: true,
    },
  },
  {
    path: '/stage-alternance/form',
    name: StudentRouteName.StageAlternanceForm,
    component: LiaisonDocumentForm,
    meta: {
      title: 'routes.stageAlternanceForm',
      requiresRoles: [UserRole.STUDENT],
      category: ROUTE_CATEGORY.STUDENT,
      hideInMenu: true,
    },
  },
  {
    path: '/study-abroad-campaign',
    name: StudentRouteName.StudentCampaigns,
    component: () =>
      import('@/features/my-study-abroad/students/views/CampaignStudentDashboard.vue'),
    meta: {
      title: 'routes.studentCampaigns',
      requiresRoles: [UserRole.STUDENT],
      category: ROUTE_CATEGORY.STUDENT,
      hideInMenu: true,
    },
  },
  {
    path: '/study-abroad-campaign/:id',
    name: StudentRouteName.StudentCampaignDetails,
    component: () => import('@/features/my-study-abroad/students/views/CampaignStudentPage.vue'),
    meta: {
      title: 'routes.studentCampaignDetails',
      requiresRoles: [UserRole.STUDENT],
      category: ROUTE_CATEGORY.STUDENT,
      hideInMenu: true,
    },
  },
  {
    path: '/study-abroad-campaign/:id/results',
    name: StudentRouteName.StudentCampaignResults,
    component: () => import('@/features/my-study-abroad/students/views/CampaignResultsPage.vue'),
    meta: {
      title: 'routes.studentCampaignResults',
      requiresRoles: [UserRole.STUDENT],
      category: ROUTE_CATEGORY.STUDENT,
      hideInMenu: true,
    },
  },
];
